<template>
  <div v-if="type === 'timeful'" class="timeful-logos">
    <v-img
      :alt="alt"
      class="shrink tw-cursor-pointer"
      contain
      :src="primarySrc"
      transition="fade-transition"
      :width="primaryWidth"
    />
    <v-img
      :alt="alt"
      class="shrink secondary-logo tw-cursor-pointer"
      contain
      :src="secondarySrc"
      transition="fade-transition"
      :width="secondaryWidth"
    />
  </div>
  <v-img
    v-else
    :alt="alt"
    class="shrink tw-cursor-pointer"
    contain
    :src="src"
    transition="fade-transition"
    :width="width"
  />
</template>

<script>
import { isPhone } from "@/utils"

export default {
  name: "Logo",

  props: {
    type: {
      type: String,
      default: "timeful",
      validator: (value) =>
        ["timeful", "betterwhen2meet", "aprilfools"].includes(value),
    },
  },

  computed: {
    isPhone() {
      return isPhone(this.$vuetify)
    },
    alt() {
      if (this.type === "betterwhen2meet") {
        return "Betterwhen2meet Logo"
      }
      return "Octocal Logo"
    },
    src() {
      switch (this.type) {
        case "betterwhen2meet":
          return require("@/assets/timeful_logo_with_text.png")
        case "aprilfools":
          return require("@/assets/timeful_logo_with_text.png")
        default:
          return require("@/assets/timeful_logo_with_text.png")
      }
    },
    width() {
      switch (this.type) {
        case "betterwhen2meet":
          return this.isPhone ? 200 : 300
        case "aprilfools":
          return this.isPhone ? 200 : 300
        default:
          return this.isPhone ? 90 : 110
      }
    },
    // Separate computed properties for timeful logos
    primarySrc() {
      return require("@/assets/timeful_logo_with_text.png")
    },
    secondarySrc() {
      return require("@/assets/timeful_logo_with_text_2.png") // Your second image
    },
    primaryWidth() {
      return this.isPhone ? 90 : 110
    },
    secondaryWidth() {
      return this.isPhone ? 60 : 125 // Adjust as needed
    },
  },
}
</script>

<style scoped>
.timeful-logos {
  display: flex;
  align-items: center;
  gap: 12px;
}

.secondary-logo {
  opacity: 0.8; /* Optional: adjust appearance of second logo */
}
</style>
